import apiClient from './apiClient';

const dashboardService = {
  // Kullanıcı istatistikleri
  getUserStats: async () => {
    try {
      const response = await apiClient.post('/user/GetAllUsers');
      const users = response.data?.Data?.Items || [];
      return {
        total: users.length,
        users: users
      };
    } catch (error) {
      console.error('User stats error:', error);
      return { total: 0, users: [] };
    }
  },

  // Ticket istatistikleri
  getTicketStats: async () => {
    try {
      const [tickets, statuses] = await Promise.all([
        apiClient.post('/ticket/GetAllTickets'),
        apiClient.post('/ticket/GetAllTicketStatuses')
      ]);

      const ticketList = tickets.data?.Data?.Items || [];
      const statusList = statuses.data?.Data?.Items || [];

      // Status bazında gruplama
      const byStatus = {};
      statusList.forEach(status => {
        byStatus[status.name] = ticketList.filter(t => t.ticketStatusId === status.id).length;
      });

      return {
        total: ticketList.length,
        byStatus,
        tickets: ticketList,
        statuses: statusList
      };
    } catch (error) {
      console.error('Ticket stats error:', error);
      return { total: 0, byStatus: {}, tickets: [], statuses: [] };
    }
  },

  // Soru istatistikleri
  getQuestionStats: async () => {
    try {
      const [questions, types] = await Promise.all([
        apiClient.post('/question/getallquestions'),
        apiClient.post('/question/getallquestiontypes')
      ]);

      const questionList = questions.data?.Data?.Items || [];
      const typeList = types.data?.Data?.Items || [];

      return {
        total: questionList.length,
        typeCount: typeList.length,
        questions: questionList,
        types: typeList
      };
    } catch (error) {
      console.error('Question stats error:', error);
      return { total: 0, typeCount: 0, questions: [], types: [] };
    }
  },

  // Üyelik paketi istatistikleri
  getMembershipStats: async () => {
    try {
      const response = await apiClient.post('/MembershipPackage/GetAllMembershipPackages');
      const packages = response.data?.Data?.Items || [];

      return {
        total: packages.length,
        packages: packages
      };
    } catch (error) {
      console.error('Membership stats error:', error);
      return { total: 0, packages: [] };
    }
  },

  // Tag istatistikleri
  getTagStats: async () => {
    try {
      const [tags, types] = await Promise.all([
        apiClient.post('/Tag/GetAllTags'),
        apiClient.post('/Tag/GetAllTagTypes')
      ]);

      const tagList = tags.data?.Data?.Items || [];
      const typeList = types.data?.Data?.Items || [];

      return {
        totalTags: tagList.length,
        totalTypes: typeList.length,
        tags: tagList,
        types: typeList
      };
    } catch (error) {
      console.error('Tag stats error:', error);
      return { totalTags: 0, totalTypes: 0, tags: [], types: [] };
    }
  },

  // Rol istatistikleri
  getRoleStats: async () => {
    try {
      const [roles, roleGroups] = await Promise.all([
        apiClient.post('/role/GetAllRoles'),
        apiClient.post('/rolegroup/GetAllRoleGroups')
      ]);

      const roleList = roles.data?.Data?.Items || [];
      const groupList = roleGroups.data?.Data?.Items || [];

      return {
        totalRoles: roleList.length,
        totalGroups: groupList.length,
        roles: roleList,
        groups: groupList
      };
    } catch (error) {
      console.error('Role stats error:', error);
      return { totalRoles: 0, totalGroups: 0, roles: [], groups: [] };
    }
  },

  // Lokasyon istatistikleri
  getLocationStats: async () => {
    try {
      const [countries, cities] = await Promise.all([
        apiClient.post('/location/GetAllCountries'),
        apiClient.post('/location/GetAllCities')
      ]);

      const countryList = countries.data?.Data?.Items || [];
      const cityList = cities.data?.Data?.Items || [];

      return {
        totalCountries: countryList.length,
        totalCities: cityList.length
      };
    } catch (error) {
      console.error('Location stats error:', error);
      return { totalCountries: 0, totalCities: 0 };
    }
  },

  // Sözleşme istatistikleri
  getAgreementStats: async () => {
    try {
      const response = await apiClient.post('/agreement/GetAllAgreements');
      const agreements = response.data?.Data?.Items || [];

      return {
        total: agreements.length,
        agreements: agreements
      };
    } catch (error) {
      console.error('Agreement stats error:', error);
      return { total: 0, agreements: [] };
    }
  },

  // Tüm istatistikleri getir
  getAllStats: async () => {
    const [users, tickets, questions, memberships, tags, roles, locations, agreements] = await Promise.all([
      dashboardService.getUserStats(),
      dashboardService.getTicketStats(),
      dashboardService.getQuestionStats(),
      dashboardService.getMembershipStats(),
      dashboardService.getTagStats(),
      dashboardService.getRoleStats(),
      dashboardService.getLocationStats(),
      dashboardService.getAgreementStats()
    ]);

    return {
      users,
      tickets,
      questions,
      memberships,
      tags,
      roles,
      locations,
      agreements
    };
  }
};

export default dashboardService;
